import api from "../../../config/gatewayConfig";
import { httpClient } from "../../httpClient";

export const apiCatalogProvider = {
  modifica: async (data) => {
    // token injection handled by httpClient interceptor
    return httpClient.post(api.modifica, data, {
      headers: { "Content-Type": "application/json" },
    });
  },

  elimina: async (data) => {
    return httpClient.post(api.elimina, data, {
      headers: { "Content-Type": "application/json" },
    });
  },

  getCatalogs: async (data) => {
    return httpClient.post(api.getCatalogs, data);
  },

  getCatalogImportDetails: async (data) => {
    return httpClient.post(api.getCatalogImportDetails, data);
  },

  importCsv: async (formData) => {
    return httpClient.post(api.importCsv, formData, {
      headers: {},
    });
  },
};

